/**
 * @license Angular v22.1.4
 * (c) 2010-2026 Google LLC. https://angular.dev/
 * License: MIT
 */

import * as i0 from '@angular/core';
import { Service, Injectable } from '@angular/core';
function parseCookieValue(cookieStr, name) {
  name = encodeURIComponent(name);
  for (const cookie of cookieStr.split(';')) {
    const eqIndex = cookie.indexOf('=');
    const [cookieName, cookieValue] = eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)];
    if (cookieName.trim() !== name) {
      continue;
    }
    let value = cookieValue;
    try {
      value = decodeURIComponent(cookieValue);
    } catch {}
    if (value.length > 1 && value[0] === '"' && value[value.length - 1] === '"') {
      value = value.slice(1, -1);
    }
    return value;
  }
  return null;
}
class BrowserXhr {
  build() {
    return new XMLHttpRequest();
  }
  static ɵfac = function BrowserXhr_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BrowserXhr)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineService({
    token: BrowserXhr,
    factory: BrowserXhr.ɵfac
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BrowserXhr, [{
    type: Service
  }], null, null);
})();
class XhrFactory {
  static ɵfac = function XhrFactory_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || XhrFactory)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: XhrFactory,
    factory: function XhrFactory_Factory(__ngFactoryType__) {
      let __ngConditionalFactory__ = null;
      if (__ngFactoryType__) {
        __ngConditionalFactory__ = new (__ngFactoryType__ || XhrFactory)();
      } else {
        /* @ts-ignore */
        __ngConditionalFactory__ = i0.ɵɵinject(BrowserXhr);
      }
      return __ngConditionalFactory__;
    },
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XhrFactory, [{
    type: Injectable,
    args: [{
      providedIn: 'root',
      useExisting: BrowserXhr
    }]
  }], null, null);
})();
export { XhrFactory, parseCookieValue };
